import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-close-btn-modal',
  templateUrl: './close-btn-modal.component.html'
})
export class CloseBtnModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
